// serviceWorkerRegistration.js
export function register(config) {

    // Ne pas enregistrer le service worker en développement
    if (process.env.NODE_ENV === 'development') {
        return;
    }

    if ('serviceWorker' in navigator) {
        window.addEventListener('load', () => {
            const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

            navigator.serviceWorker
                .register(swUrl)
                .then((registration) => {
                    if (process.env.NODE_ENV !== 'production') console.log('Service Worker enregistré avec succès:', registration);
                })
                .catch((error) => {
                    console.error("Erreur lors de l'enregistrement du Service Worker:", error);
                });
        });
    }
}

export function unregister() {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.ready.then((registration) => {
            registration.unregister();
        });
    }
}
